import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTCLI_Overview } from './Overview.messages.json';
import styles from './Overview.scss';

const Overview = () => (
  <p className={styles.root}>
    <Translation {...TXTCLI_Overview} />
  </p>
);

export default Overview;
